import {Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import {FormattedNumber} from 'react-intl'
import {useOrderSummary} from './order-summary-provider'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

const OrderSummaryPriceAdjustmentItem = ({adjustment}) => {
    const basket = useOrderSummary()
    const {isCustomNetPriceEnabled} = useCurrentCustomer().data
    return (
        <>
            <Text>{adjustment.itemText}</Text>
            <Text whiteSpace="nowrap">
                {isCustomNetPriceEnabled ? (
                    <FormattedNumber
                        style="currency"
                        currency={basket?.currency}
                        value={adjustment.c_netPrice}
                    />
                ) : (
                    <FormattedNumber
                        style="currency"
                        currency={basket?.currency}
                        value={adjustment.price}
                    />
                )}
            </Text>
        </>
    )
}

OrderSummaryPriceAdjustmentItem.propTypes = {
    adjustment: PropTypes.object.isRequired
}

export default OrderSummaryPriceAdjustmentItem
